// Returns new copy of the array passed as an argument, but with no duplicates
const removeDuplicates = (array: any[]) =>
  array?.reduce((accumulator, value) => (accumulator.includes(value) ? accumulator : [...accumulator, value]), []);

export default removeDuplicates;
